import { createSlice } from "@reduxjs/toolkit";
import lang from "../assets/lang/icons.json";

const initialState = {
  profileFormData: [
    {
      profileFormData: false,
    },
  ],

  data: [
    {
      firstName: `${lang.staticTemp.firstName}`,
      lastName: `${lang.staticTemp.lastName}`,
      title: `${lang.staticTemp.title}`,
      companyName: `${lang.staticTemp.companyName}`,
      department: `${lang.staticTemp.department}`,
      mobile_number: `${lang.staticTemp.mobile_number}`,
      website: `${lang.staticTemp.website}`,
      bannerUrl: `${lang.staticTemp.bannerUrl}`,
      email: `${lang.staticTemp.email}`,
      address: `${lang.staticTemp.address}`,
      instagram: `${lang.staticTemp.instagram}`,
      facebook: `${lang.staticTemp.facebook}`,
      twitter: `${lang.staticTemp.twitter}`,
      linkedIn: `${lang.staticTemp.linkedIn}`,
    },
  ],
  
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    profileFormData: (state, action) => {
      if (action.payload === "") {
        state.profileFormData = [];
        state.profileFormData = [
          ...state.profileFormData,
          initialState.profileFormData[0],
        ];
      } else {
        const profileFormData = action.payload;
        state.profileFormData = [];
        state.profileFormData = [...state.profileFormData, { profileFormData }];
      }
    },

    formDetails: (state, action) => {
      // console.log(Object.values(action.payload).every(el => el == ''));
      // console.log(action.payload)
      if (Object.values(action.payload).every((el) => el === "")) {
        state.data = [];
        state.data = [...state.data, initialState.data[0]];
      } else {
        state.data = [];
        state.data = [...state.data, action.payload];
      }
    },


    resetformDetails: (state) => {
      state.data = [];
      state.data = [...state.data, initialState.data[0]];
    },
  },
});

// Action creators are generated for each case reducer function
export const { formDetails, profileFormData, resetformDetails } =
  userSlice.actions;

export default userSlice.reducer;
